import { useState } from 'react';
import { useReportDateRange } from '@/hooks/useReportDateRange';
import { reportsApi } from '@/services/api';
import { downloadCsv } from '@/utils/csv';
import PurchaseReportFilters from '../shared/PurchaseReportFilters';
import ReportDataTable, { columnsToCsvHeaders, rowsToCsvData } from '../shared/ReportDataTable';
import ReportLayout from '../shared/ReportLayout';
import { fetchPurchaseReportExport, usePurchaseReport } from '../shared/usePurchaseReport';
import { activityInvoiceColumns, ActivityInvoiceRow } from './columns';

export default function PurchaseActivityInvoicePage() {
  const dateRangeHook = useReportDateRange('This Month');
  const { from_date, to_date } = dateRangeHook;
  const [supplier, setSupplier] = useState('');
  const [supplierLabel, setSupplierLabel] = useState('');
  const [status, setStatus] = useState('');
  const [invoice, setInvoice] = useState('');

  const params = {
    from_date,
    to_date,
    supplier: supplier || undefined,
    status: status || undefined,
    invoice: invoice || undefined,
  };

  const { rows, total, page, setPage, pageSize, isLoading } = usePurchaseReport({
    queryKey: 'purchaseActivityInvoice',
    params,
    fetcher: (p) => reportsApi.getPurchaseActivityInvoice(p),
  });

  const handleExport = async () => {
    const data = await fetchPurchaseReportExport(reportsApi.getPurchaseActivityInvoice, params);
    downloadCsv(
      `purchase-activity-invoice-${from_date}-${to_date}.csv`,
      columnsToCsvHeaders(activityInvoiceColumns),
      rowsToCsvData(data.rows as unknown as ActivityInvoiceRow[], activityInvoiceColumns),
    );
  };

  return (
    <ReportLayout
      onExport={handleExport}
      exportDisabled={!total}
      isLoading={isLoading}
      isEmpty={!rows.length}
      page={page}
      total={total}
      pageSize={pageSize}
      onPageChange={setPage}
      filters={
        <PurchaseReportFilters
          dateRangeHook={dateRangeHook}
          supplier={supplier}
          supplierLabel={supplierLabel}
          onSupplierChange={(id, label) => {
            setSupplier(id);
            setSupplierLabel(label);
          }}
          status={status}
          onStatusChange={setStatus}
          invoice={invoice}
          onInvoiceChange={setInvoice}
          showStatus
          showInvoice
        />
      }
    >
      <ReportDataTable data={rows as never[]} columns={activityInvoiceColumns} />
    </ReportLayout>
  );
}
